<template>
  <el-dialog
    :visible.sync="dialogModel"
    :custom-class="`inline-block lordless-dialog message-dialog center mobile-center no-header transparent`"
    width="100%"
    append-to-body
    center
    top="-20px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    @open="$emit('open')"
    @close="$emit('close')">
    <div class="text-center lordless-message-box dialog-plan-glossary-dialog">
      <span
        @click.stop="$emit('input', false)"
        class="inline-block line-height-1 lordless-message-close">
        <i class="el-icon-close"></i>
      </span>
      <h2>{{ reminderInfo.title }}</h2>
      <p class="plan-glossary-desc">{{ reminderInfo.desc }}</p>
      <p class="TTFontBolder recruit-reminder-text">Are you sure to continue?</p>
      <p class="plan-glossary-btns">
        <lordless-btn class="plan-glossary-btn" theme="dialog" @click="$emit('confirm')">YES</lordless-btn>
      </p>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'lordless-plan-glossary-dialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      dialogModel: false,
      reminderInfo: {
        title: 'Tx Reminder',
        desc: 'The amount of recruits is reaching the limit. Your transaction may fail because the confirmation of transaction on Ethereum depends on the miners.'
      }
    }
  },
  watch: {
    value (val) {
      this.dialogModel = val
      this.$emit('blurs', val)
    }
  }
}
</script>

<style lang="scss" scoped>
  .lordless-message-box {
    max-width: 480px;
    padding-top: 60px;
    padding-bottom: 50px;
  }
  .lordless-glossary {
    position: absolute;
    top: 18px;
    left: 18px;
    font-size: 12px;
    color: #fff;
  }
  .dialog-plan-glossary-dialog {
    // font-size: 16px;
    color: #fff;
    fill: #fff;
    @include fontSize(18px, 1.125);
    >h2 {
      font-size: 24px;
    }
  }
  .plan-glossary-desc {
    margin-top: 18px;
    font-size: 16px;
  }
  .recruit-reminder-text {
    margin-top: 12px;
    font-size: 16px;
  }

  .plan-glossary-btns {
    margin-top: 36px;
  }
  .plan-glossary-btn {
    padding: 0 16px;
    height: 43px;
    line-height: 43px;
    @include fontSize(18px, 1.125);
  }
</style>



// WEBPACK FOOTER //
// src/components/reuse/dialog/recruit/reminder.vue